module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Licences "), (_vm.is_external) ? _c('small', [_vm._v("View existing licences and amend or renew them")]) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": '#' + _vm.pBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pBody
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Licence Category")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterLicenceType),
      expression: "filterLicenceType"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterLicenceType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.licence_categories), function(l) {
    return _c('option', {
      key: ("cat_" + l),
      domProps: {
        "value": l
      }
    }, [_vm._v(_vm._s(l))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Licence Holder")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterLicenceHolder),
      expression: "filterLicenceHolder"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filterLicenceHolder = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "All"
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.licence_holders), function(holder) {
    return _c('option', {
      key: ("licence_holder_" + (holder.holder_name)),
      domProps: {
        "value": holder.holder_name
      }
    }, [_vm._v(_vm._s(holder.holder_name))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Issued From")]), _vm._v(" "), _c('div', {
    ref: "licenceDateFromPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterLicenceIssuedFrom),
      expression: "filterLicenceIssuedFrom"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterLicenceIssuedFrom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterLicenceIssuedFrom = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Issued To")]), _vm._v(" "), _c('div', {
    ref: "licenceDateToPicker",
    staticClass: "input-group date"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterLicenceIssuedTo),
      expression: "filterLicenceIssuedTo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.filterLicenceIssuedTo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterLicenceIssuedTo = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('datatable', {
    ref: "licence_datatable",
    attrs: {
      "id": _vm.datatable_id,
      "dtOptions": _vm.licence_options,
      "dtHeaders": _vm.licence_headers
    }
  })], 1)])])])]), _vm._v(" "), _c('LicenceActionPurposes', {
    ref: "licence_action_purposes",
    attrs: {
      "licence_activity_purposes": _vm.action_purpose_list,
      "licence_id": _vm.selected_licence_id,
      "action": _vm.licence_action
    },
    on: {
      "refreshFromResponse": _vm.refreshFromResponse
    }
  }), _vm._v(" "), _c('InspectionRequest', {
    ref: "inspection",
    on: {
      "inspection-created": _vm.requestedInspection
    }
  }), _vm._v(" "), _c('LicenceHistory', {
    ref: "licence_history"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17ccd146"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/licences_dashboard.vue
// module id = 927
// module chunks = 0